import { TLShapeId, TLStoreSnapshot } from "tldraw";
import { request, ResponseData } from "./instance";
import { UserInfo } from "./User/userTypes";

export interface ChatMessagesItem {
  message?: any;
  name?: string;
  role?: string;
  content?: any;
  first?: boolean;
  audioIndex?: number;
  isVoice?: boolean;
  sid?: string;
  resources?: {
    possibleResponses?: string[];
    location?: SubmitLocationParams;
  };
  slideId?: string;
  taskId?: number;
  language?:string;
  actions?:any[];
}

export enum WorkInfoStatus {
  NoPermission = 0, // 没有权限
  HasPermission = 1, // 有权限
  LessonComplete = 2, // 创作可是已经用完
}

// 课程类型
export enum courseTypeEnum {
  A = "a",
  Math = "m",
  EnglishRead = "er"
}

export interface IntroItemInfo {
  title: string;
  id: number;
  markdown: string;
}

export interface ProcessItem {
  state: 0 | 1 | 2; // 0 未完成 1 进行中 2 已完成
  type: "knowledge" | "question";
  slide: string;
  taskId: string;
}

export interface WorkInfo {
  panelUrl: string;
  workId: string;
  workName: string;
  panel?: string;
  workImg: string;
  status?: number;
  lessonId?: string;
  lessonType:string;
  chatMessages?: ChatMessagesItem[];
  remainingRounds: number;
  usedRounds: number;
  shapeIndex: number;
  userId?: string;
  currentSlideId: string;
  currentTaskId?: number;
  lessonEnd?: boolean;
  lessonTitle?: string;
  learnProcess: ProcessItem[];
  snapshot?: SnapshotData;
  showAddIntegral: boolean;
  addIntegral: number;
  courseType: string;
  courseId: number;
  classOver: number;
  situation: {
    timer: number;
    video?: {
      currentPosition: number;
      slideId: string;
      userSpentDuration: number;
    };
  };
  seriesId?: number;
}

export interface WorkList {
  works: WorkInfo[];
  totalPage: number;
}

export interface WorkInfoParams {
  lessonId?: string;
  workId?: string;
  type?: string;
}

export interface SaveWorkParams {
  workId: string;
  workName: string;
  panelJson?: string;
  workImg?: string;
  situation: { timer: number };
}

export interface PanelDataParams {
  url: string;
}

type StringKey = Record<string, any>;
export type UploadFile = {
  file?: any;
  function: string;
};

export type VipItem = {
  vipType: string;
  realAmount: number;
  originalAmount: string;
  rights: string[];
  activated: boolean;
  validityRange: string;
  remainingRounds: number;
};

export type VipInfo = {
  createPermission: boolean;
  vips: VipItem[];
};

export type createOrderParams = {
  vipType: string;
  channel?: string;
  outside?: string;
  shareId?: string;
};

export type PayOrderParams = {
  orderId: string;
  payType: 1 | 2; // 1微信，2支付宝
  outside?: string;
  shareId?: string;
};

export type QueryOrderParams = {
  orderId: string;
};

export type WorkListParams = {
  workName: string;
  page?: number;
};

export type SubmitLocationParams = {
  workId?: string;
  shapeId?: TLShapeId;
  type: "dalle" | "coder" | "message" | "slide" | "illustrator";
  sid: string;
  slideId?: TLShapeId;
  courseType?: string;
  lessonId?: string;
};

export type DeleteWorkParams = {
  workId: string;
};

export type CourseInfo = {
  id: number;
  title: string;
  seriesId: number; //注意;对于seriesId = 6;点击去上课;跳转规则不一样;不用alias来跳转
  alias: string;
  courseAge: string;
  courseImg: string;
  lessonCount: number;
  courseProgress: string; //学习进度
  currentLessonNum: number; //当前学习到的课时
  currentFeLessonNum: number;
  currentLessonTitle: string; //当前学习课时名称
  learnStatus: number; //学习状态;判断规则和我的课程列表判断规则一致
  saleStatus: number; //注意;有等待开放的状态
  permission: boolean;
  courseEnd: boolean;
  courseStatus: number;
  currentLessonId: number;
};

type PayState = 0 | 1 | 2 | 3 | 4 | 5 | 6; // 支付状态

type PayType = 1 | 2; // 支付类型

export interface OrderInfo {
  orderId: number;
  userId: string;
  payState: PayState; // 0未支付，1待支付，2已支付，3退款中，4已退款，5已过期，6已取消
  payType: PayType; // 1微信，2支付宝
  realAmount: number;
  originalAmount: number;
  vipType: string;
  validityRange: string;
  wxCodeUrl: string;
  aliCodeUrl: string;
  orderBeginStamp: number; // 订单开始时间
  payBeginStamp: number | null;
  paySuccessStamp: number | null;
  orderRemaining: number; // 订单剩余时间
  payRemaining: number | null;
  qrCodeUrl?: string;
}

export interface ShareLink {
  shareId: string;
  courseId: number;
}

export interface VipUser {
  userId: string;
  vipType: string;
  options: string[];
  rights: string[];
  validityRange: string;
  activated: boolean;
  remainingRounds: number;
}

export interface HomeInfo {
  vip: VipItem;
  recommendCourse: boolean;
  courses: CourseInfo[];
  works: WorkInfo[];
  user?: UserInfo;
}

export interface HomeInit {
  code?: string;
  url: string;
}

interface SnapshotData extends TLStoreSnapshot {
  shapeCacheList?: any;
  nextBounds?: any;
  slideTools?: any;
  aiShapeText?: any;
}

export type ClassOverInfo = {
  nextLessonId: number;
  hasNextLesson: boolean;
  addIntegral?: number;
  showAddIntegral?: false;
};

export type SlideSummary = {
  nextLessonId: number;
  passExercises: number;
  chatNumbers: number;
  content: string;
  hasReport: boolean;
};

export type SlideReport = {
  chatMessages: any[];
  chatNumber: number;
  lessonId: number;
  nickname: string;
  passExercises: number;
  summary: any[];
  words: number | null;
};

export const headers = { "Content-Type": "application/json" };

export const fetchHomeInit = async (
  userId: string | undefined
): Promise<ResponseData<HomeInit>> => {
  let url = "community/work/home/init";
  if (userId) {
    url += `?userId=${userId}`;
  }
  const resp = await request(url);
  return resp;
};

export const fetchHomePointList = async (): Promise<
  ResponseData<IntroItemInfo[]>
> => {
  let url = "community/home/point/list";

  const resp = await request(url);
  return resp;
};

export const fetchIntroItemInfo = async (
  pointId: string
): Promise<ResponseData<IntroItemInfo>> => {
  let url = "community/home/point/info";
  if (pointId) {
    url += `?pointId=${pointId}`;
  }
  const resp = await request(url);
  return resp;
};

export const fetchWorkInfo = async (
  params: WorkInfoParams
): Promise<ResponseData<WorkInfo>> => {
  let url = "community/work/info";
  if (params.type === courseTypeEnum.Math || params.type === courseTypeEnum.EnglishRead) {
    url = "course/slide/learn/info";
  }
  const resp = await request(url, { params });
  return resp;
};

export const fetchSlideClassOverInfo = async (params: {
  lessonId: string;
  type: string;
}): Promise<ResponseData<ClassOverInfo>> => {
  let url = "community/work/classOver";
  if (params.type === courseTypeEnum.Math || params.type === courseTypeEnum.EnglishRead) {
    url = "course/slide/learn/classOver";
  }
  const resp = await request(url, { params });
  return resp;
};

export const fetchSlideSummary = async (params: {
  lessonId: string;
  type: string;
}): Promise<ResponseData<SlideSummary>> => {
  let url = "community/work/summary";
  if (params.type === courseTypeEnum.Math || params.type === courseTypeEnum.EnglishRead) {
    url = "course/slide/learn/summary";
  }
  // const resp = await request(url, { params });
  const resp = await request(
    url,
    {
      method: "POST",
      data: { lessonId: params.lessonId, type: params.type },
      headers,
    },
    true
  );
  return resp;
};

export const fetchSlideReport = async (params: {
  lessonId: string;
  type: string | undefined;
}): Promise<ResponseData<SlideReport>> => {
  let url = "community/work/download/report ";
  if (params.type === courseTypeEnum.Math || params.type === courseTypeEnum.EnglishRead) {
    url = "course/slide/download/report";
  }
  // const resp = await request(url, { params });
  const resp = await request(
    url,
    {
      method: "POST",
      data: { lessonId: params.lessonId, type: params.type },
      headers,
    },
    true
  );
  return resp;
};

export const fetchWorkList = async (
  data: WorkListParams
): Promise<ResponseData<WorkList>> => {
  const resp = await request("community/work/list", {
    method: "POST",
    data,
    headers,
  });
  return resp;
};

export const queryOrder = async (
  data: QueryOrderParams
): Promise<ResponseData<OrderInfo>> => {
  const resp = await request("order/vip/query", {
    method: "POST",
    data,
    headers,
  });
  return resp;
};

export const fetchVipInfo = async (): Promise<ResponseData<VipInfo>> => {
  const resp = await request("community/vip/info");
  return resp;
};

export const fetchShareLink = async (): Promise<ResponseData<ShareLink>> => {
  const resp = await request("community/share/link");
  return resp;
};

export const fetchVipUser = async (): Promise<ResponseData<VipUser>> => {
  const resp = await request("community/vip/user");
  return resp;
};

export const fetchHomeInfo1 = async (): Promise<ResponseData<HomeInfo>> => {
  const resp = await request("community/home/info");
  return resp;
};

export const fetchHomeInfo = async (): Promise<ResponseData<HomeInfo>> => {
  const resp = await request("course/new/home");
  return resp;
};

// 提交消息位置信息
export const submitLocation = async (
  data: SubmitLocationParams
): Promise<ResponseData> => {
  let url = "community/work/location";
  if (data.courseType === courseTypeEnum.Math || data.courseType === courseTypeEnum.EnglishRead) {
    url = "course/slide/learn/location";
  }
  const resp = await request(url, {
    method: "POST",
    data,
    headers,
  });
  return resp;
};

// 提交视频播放进度
export type SubmitVideoProgressParams = {
  lessonId: number;
  slideId: string;
  currentPosition: number; // 单位是秒
  userSpentDuration?: number; // 用户累计观看该视频的总时长，单位是秒
};

export type VideoProgressResponse = {
  lessonId: number;
  slideId: string;
  currentPosition: number; // 单位是秒
  userSpentDuration: number; // 用户累计观看该视频的总时长，单位是秒
};

export const submitVideoProgress = async (
  data: SubmitVideoProgressParams
): Promise<ResponseData<VideoProgressResponse>> => {
  const resp = await request("course/video/progress", {
    method: "POST",
    data,
    headers,
  });
  return resp;
};

// 删除作品
export const deleteWork = async (
  data: DeleteWorkParams
): Promise<ResponseData> => {
  const resp = await request("community/work/delete", {
    method: "POST",
    data,
    headers,
  });
  return resp;
};

export const saveWork = async (
  data: SaveWorkParams
): Promise<ResponseData<WorkInfo>> => {
  const resp = await request("community/work/save", {
    method: "POST",
    data,
    headers,
  });
  return resp;
};

export const creatOrder = async (
  data: createOrderParams
): Promise<ResponseData<OrderInfo>> => {
  const resp = await request("order/vip/create", {
    method: "POST",
    data,
    headers,
  });
  return resp;
};

export const payOrder = async (
  data: PayOrderParams
): Promise<ResponseData<OrderInfo>> => {
  const resp = await request("order/vip/pay", {
    method: "POST",
    data,
    headers,
  });
  return resp;
};

export const fetchUploadFile = async (
  data: StringKey
): Promise<ResponseData<string>> => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data![key]);
  });
  const resp = await request("upload/obs/file", {
    method: "POST",
    body: formData,
  });
  return resp;
};

export const fetchPanelData = async (
  params: PanelDataParams
): Promise<SnapshotData> => {
  const resp = await request(`${params.url}?v=${+new Date()}`);
  return resp;
};

export const fetchAppDownload = async (): Promise<ResponseData> => {
  const resp = await request("pad/download");
  return resp;
};

export const clearUserMessage = async (workId: string) => {
  const resp = await request(`community/work/clear/messages?workId=${workId}`, {
    method: "POST",
  });
  return resp;
};

export const createNewChat = async (workId: string) => {
  const resp = await request(`community/work/reset/messages?workId=${workId}`, {
    method: "POST",
  });
  return resp;
};
